module.exports = " <div class=publish-fields> <component v-for=\"(i, field) in fields\" :is=componentName(field) :field=field :data.sync=data[field.name] :config=fields[$index] :autofocus=\"autofocus && i == 0\" :env=definedInEnvironment(field.name)></component> </div> ";


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-html-loader!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./app/statamic/resources/js/components/publish/Fields.vue
// module id = 317
// module chunks = 0